import { Observable } from "rxjs";

export interface IGroupMemberOrderDetailService {
  /** user made changes : groupbasket item count,comment or menucourse */
  readonly hasChanges$: Observable<boolean>;
  /** member items in grouzp basket (own items) */
  readonly memberGroupBasketItems$: Observable<ReadonlyArray<IMemberGroupBasketItem>>
  /** menucourse */
  readonly menucourses$: Observable<IMenuCourse[]>;
  /** member ordered items (own items) */
  readonly memberOrderedItems$: Observable<ReadonlyArray<IMemberOrderedItem>>;
  /** member info */
  readonly memberInfo$: Observable<IMemberInfo>;
  /** user is owner (used to allow basket modification and display ready for pick up) */
  readonly isOwner: boolean;
  /** open price ordered items price + item price in group basket*/
  readonly open_price$: Observable<number>;
  /** user phone number */
  readonly phoneNumber$: Observable<string>;
  /** initialisiert sich anhand des users */
  initialise(userToken: string): Promise<void>;

  /** markiere abholbereite artikel als gelesen */
  noticeItems(): Promise<void>;
  /** ändert die Notification auf SMS mit engegebener Nummer */
  ChangePhoneNumber(number: string): Promise<boolean>;
}

/** Benachrichtigungsart */
export enum IMemberInfo_NotificationTyp {
  /** Keine Benachrichtigung */
  NONE = 0,
  /** Per WebPush */
  WebPush = 1,
  /** Per SMS */
  SMS = 2,
  /** Per FCM (Firebase Cloud Messaging) */
  FCM = 3,
}

export interface IMemberInfo {
  readonly name: string;
  /** art der notification */
  readonly notificationTyp: IMemberInfo_NotificationTyp;
  /** count of readyForPickup items */
  readonly readyForPickUpCount: number;
}

export interface IItem {
  readonly id: number;
  readonly label: string;
  readonly valid_date?: number;
  readonly deposit?: number;
  readonly variable_price?: number;
  readonly extras?: ReadonlyArray<IItemExtra>;
  readonly count: number;
  readonly price: number;
  comment: string;
  readonly hasComment: boolean;
  readonly use_menucourse: boolean;
  menucourse: number;
}

export interface IItemExtra {
  /** extra name */
  readonly title: string
  /** extra subIndex (positiv und negativ erzeugen die Verkettung) */
  readonly subIndex: number;
  /** extra count */
  readonly count: number;
}

export interface IMemberGroupBasketItem extends IItem {
  readonly canComment: boolean;
  readonly canIncrement: boolean;
  increment();
  readonly canDecrement: boolean;
  decrement();
}

export enum OrderedItemState {
  None = 0,
  InPreperation = 1,
  ReadyForPickUp = 2,
  PickedUp = 3
}

export interface IMemberOrderedItem extends IItem {
  readonly comment: string;
  readonly menucourse: number;
  readonly state: OrderedItemState;
}

export interface IMenuCourse {
  readonly name: string;
  readonly id: number;
}